"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _webValidations = require("@mhub/web-validations");

var _reactDatasheet = _interopRequireDefault(require("react-datasheet"));

var _lib = require("../../lib");

var _common = require("../../common");

var _Cell = _interopRequireDefault(require("../Table/Cell"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Datasheet =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Datasheet, _PureComponent);

  function Datasheet(props) {
    var _this;

    _classCallCheck(this, Datasheet);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Datasheet).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getKeyExtractor", function (data, idx, selector) {
      var keyExtractor = _this.props.keyExtractor;

      if (keyExtractor) {
        return keyExtractor(data, idx, selector);
      }

      return idx;
    });

    _defineProperty(_assertThisInitialized(_this), "getFormattedData", function (data) {
      var columns = _this.props.columns;
      var formattedData = [];
      var headerRow = data[0];
      data.forEach(function (row, rowIndex) {
        // ignore header
        if (rowIndex === 0) return;
        var rowData = {};
        row.forEach(function (cell, cellIdx) {
          var column = columns.find(function (c) {
            return c.header === headerRow[cellIdx].value;
          });

          if (column) {
            var name = column.name;
            var value = cell.value;
            rowData[name] = value;
          }
        });
        formattedData.push(rowData);
      });
      return formattedData;
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var propNames = ['styled'];
      var names = [Datasheet.className];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "cellClassNames", function (cell) {
      var className = cell.className,
          cellData = cell.cell;
      var propNames = ['error'];
      var names = [className];
      (0, _lib.addClassByPropName)(names, cellData, propNames);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange",
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(changes) {
        var _this$state, data, rawData, oldRawData, newData, values, errors;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$state = _this.state, data = _this$state.data, rawData = _this$state.rawData;
                oldRawData = (0, _lib.deepCopy)(rawData);

                if (!(0, _lib.arrayHasItems)(changes)) {
                  _context3.next = 9;
                  break;
                }

                newData = [].concat(data);
                values = [];
                errors = []; // update datasheet data

                _context3.next = 8;
                return (0, _lib.asyncForEach)(changes,
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  regeneratorRuntime.mark(function _callee(c) {
                    var rowIndex, colIndex, newValue, name, validationResult, value, isValid, message;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            rowIndex = c.row, colIndex = c.col, newValue = c.value, name = c.cell.name;
                            _context.next = 3;
                            return _this.handleValidate(colIndex, rowIndex, newValue);

                          case 3:
                            validationResult = _context.sent;
                            // generate value
                            value = _this.generateValue(c, rawData); // update raw data

                            rawData[rowIndex - 1] = _objectSpread({}, rawData[rowIndex - 1], _defineProperty({}, name, newValue)); // update cell value

                            newData[rowIndex][colIndex] = _objectSpread({}, newData[rowIndex][colIndex], {
                              value: newValue,
                              error: false
                            });

                            if (!validationResult) {
                              _context.next = 13;
                              break;
                            }

                            isValid = validationResult.isValid, message = validationResult.message; // update cell error

                            newData[rowIndex][colIndex].error = !isValid; // push into errors arr

                            if (isValid) {
                              _context.next = 13;
                              break;
                            }

                            errors.push({
                              value: value,
                              rowIndex: rowIndex,
                              colIndex: colIndex,
                              message: message
                            });
                            return _context.abrupt("return");

                          case 13:
                            values.push(value);

                          case 14:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 8:
                _this.setState({
                  data: newData,
                  rawData: rawData
                },
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee2() {
                  var _this$props, onChange, onError;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          // fix snackbar key issue with async
                          _this$props = _this.props, onChange = _this$props.onChange, onError = _this$props.onError;

                          if (!((0, _lib.arrayHasItems)(values) && onChange)) {
                            _context2.next = 4;
                            break;
                          }

                          _context2.next = 4;
                          return onChange(null, {
                            value: values,
                            data: rawData,
                            oldData: oldRawData
                          });

                        case 4:
                          if (!((0, _lib.arrayHasItems)(errors) && onError)) {
                            _context2.next = 7;
                            break;
                          }

                          _context2.next = 7;
                          return onError(null, {
                            errors: errors,
                            data: rawData,
                            oldData: oldRawData
                          });

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleValidate",
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(colIndex, rowIndex, value) {
        var columns, rawData, column, validations, selector, name, rowData, rowValue, validateProps, result;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                columns = _this.props.columns;

                if (!(0, _lib.arrayHasItems)(columns)) {
                  _context4.next = 13;
                  break;
                }

                rawData = _this.state.rawData;
                column = columns[colIndex];
                validations = column.validations, selector = column.selector, name = column.name;
                rowData = rawData[rowIndex - 1];
                rowValue = (0, _lib.getSelectorValue)(rowData, selector);

                if (!validations) {
                  _context4.next = 13;
                  break;
                }

                validateProps = {
                  value: value,
                  name: name,
                  validations: (0, _lib.getRenderProps)(validations, {
                    data: rowData,
                    value: rowValue,
                    colIndex: colIndex,
                    rowIndex: rowIndex - 1
                  })
                };
                _context4.next = 11;
                return (0, _webValidations.validate)(validateProps);

              case 11:
                result = _context4.sent;
                return _context4.abrupt("return", result);

              case 13:
                return _context4.abrupt("return", null);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x3, _x4, _x5) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "generateValue", function (change, data) {
      var cellData = change.cell,
          row = change.row,
          value = change.value;
      var name = cellData.name,
          oldValue = cellData.value; // rowIndex consists of Header row which does not count based on our format

      var rowIndex = row - 1;
      var rowData = data[rowIndex];
      return {
        name: name,
        value: value,
        oldValue: oldValue,
        index: rowIndex,
        data: _objectSpread({}, rowData, _defineProperty({}, name, value)),
        oldData: rowData
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnCellChange", function (e, _ref5) {
      var name = _ref5.name,
          newValue = _ref5.value,
          rowIndex = _ref5.rowIndex,
          colIndex = _ref5.colIndex;
      var _this$state2 = _this.state,
          data = _this$state2.data,
          rawData = _this$state2.rawData;
      var oldRawData = (0, _lib.deepCopy)(rawData); // rowIndex consists of Header row which does not count based on our format

      var rowIdx = rowIndex + 1;

      if ((0, _lib.arrayHasItems)(data)) {
        var newData = [].concat(data); // update cell value

        newData[rowIdx][colIndex] = _objectSpread({}, newData[rowIdx][colIndex], {
          value: newValue
        }); // manually declare changes

        var changes = {
          cell: {
            name: name,
            value: rawData[rowIndex][name]
          },
          row: rowIdx,
          value: newValue
        }; // generate value

        var value = _this.generateValue(changes, rawData); // update raw data


        rawData[rowIndex] = _objectSpread({}, rawData[rowIndex], _defineProperty({}, name, newValue));

        _this.setState({
          data: newData,
          rawData: rawData
        }, function () {
          var onChange = _this.props.onChange;

          if (onChange) {
            onChange(null, {
              value: [value],
              data: rawData,
              oldData: oldRawData
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderColumn", function (cell) {
      var columns = _this.props.columns;

      if ((0, _lib.arrayHasItems)(columns)) {
        var colIndex = cell.col,
            row = cell.row,
            _cellData = cell.cell,
            _rest = _objectWithoutProperties(cell, ["col", "row", "cell"]);

        var value = _cellData.value;

        var _classNames = _this.cellClassNames(cell);

        var headerRow = row === 0;
        var column = columns[colIndex];

        if (column && !headerRow) {
          var selector = column.selector,
              render = column.render;

          if (render) {
            var rawData = _this.state.rawData; // rowIndex consists of Header col which does not count based on our format

            var rowIndex = row - 1;
            var data = rawData[rowIndex];

            var key = _this.getKeyExtractor(data, colIndex, selector);

            return (0, _lib.getRenderProps)(render, column, colIndex, {
              rowIndex: rowIndex,
              data: data,
              key: key,
              value: value,
              classNames: _classNames,
              onChange: _this.handleOnCellChange
            }, _rest);
          }
        }
      }

      var updated = cell.updated,
          editing = cell.editing,
          attributesRenderer = cell.attributesRenderer,
          cellData = cell.cell,
          rest = _objectWithoutProperties(cell, ["updated", "editing", "attributesRenderer", "cell"]);

      var classNames = _this.cellClassNames(cell);

      return _react.default.createElement(_Cell.default, _extends({}, rest, {
        className: classNames
      }));
    });

    var _data = props.data;
    _this.state = {
      prevProps: {
        data: _data
      },
      data: Datasheet.getDatasheetData(props),
      rawData: Object.assign({}, _data)
    };
    return _this;
  }

  _createClass(Datasheet, [{
    key: "render",
    value: function render() {
      var selector = this.props.selector;
      var data = this.state.data;
      var classNames = this.classNames();
      return _react.default.createElement(_reactDatasheet.default, {
        className: classNames,
        data: data,
        onCellsChanged: this.handleOnChange,
        cellRenderer: this.renderColumn,
        valueRenderer: selector
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var data = props.data;
      return {
        // Store the previous props in state
        prevProps: {
          data: data
        },
        data: prevProps.data !== data ? Datasheet.getDatasheetData(props) : state.data,
        rawData: prevProps.data !== data ? Object.assign({}, data) : state.rawData
      };
    } // format raw data to datasheet data

  }, {
    key: "getDatasheetData",
    value: function getDatasheetData(props) {
      var columns = props.columns,
          data = props.data;
      var datasheetData = [];
      var headerRow = [];

      if ((0, _lib.arrayHasItems)(columns)) {
        columns.forEach(function (column) {
          var header = column.header; // package requires key 'value', can be changed through selector props. headerCell by default readOnly : true

          var headerCell = {
            value: header,
            readOnly: true
          };
          headerRow.push(headerCell);
        });
      }

      if ((0, _lib.arrayHasItems)(data)) {
        data.forEach(function (d) {
          var row = [];

          if ((0, _lib.arrayHasItems)(columns)) {
            columns.forEach(function (column) {
              var selector = column.selector,
                  disabled = column.disabled,
                  readOnly = column.readOnly,
                  header = column.header,
                  rest = _objectWithoutProperties(column, ["selector", "disabled", "readOnly", "header"]); // package requires key 'value', can be changed through selector props.


              var value = (0, _lib.getSelectorValue)(d, selector);

              var cell = _objectSpread({
                value: value,
                disableEvents: readOnly,
                readOnly: disabled,
                error: false
              }, rest);

              if (cell) {
                row.push(cell);
              }
            });
          }

          datasheetData.push(row);
        });
      }

      datasheetData.unshift(headerRow);
      return datasheetData;
    } // getter

  }]);

  return Datasheet;
}(_react.PureComponent);

exports.default = Datasheet;

_defineProperty(Datasheet, "className", 'MHub-Datasheet');

_defineProperty(Datasheet, "Cell", _Cell.default);

_defineProperty(Datasheet, "propTypes", {
  data: _propTypes.default.arrayOf(_propTypes.default.any),
  onChange: _propTypes.default.func,
  onError: _propTypes.default.func,
  columns: _common.customPropTypes.tableColumns,
  keyExtractor: _propTypes.default.func,
  selector: _propTypes.default.func,
  styled: _propTypes.default.bool
});

_defineProperty(Datasheet, "defaultProps", {
  data: null,
  onChange: null,
  onError: null,
  columns: [],
  keyExtractor: null,
  selector: function selector(cell) {
    return cell.value;
  },
  styled: false
});